export default __webpack_public_path__ + "static/media/char_head_001.3741778a.png";